module.exports = __webpack_public_path__ + "static/media/xvc.8459152a.svg";